// ---------------------------------------------------------------------------
// BellStatusPage — Super Admin bell status entry point.
// ---------------------------------------------------------------------------
// Defaults to the "All Schools Today" overall view. The super-admin switches to
// a single school's day-/hour-wise week console by picking that school from the
// "View" dropdown; "All schools" returns to the overall view. Both views share
// the school dropdown list and the EN/NE language toggle, owned here.
// ---------------------------------------------------------------------------
import React, {useEffect, useState} from "react";

import {fetchSchools} from "../../services/BellStatusService";
import OverallBellStatus from "../OverallBellStatus/OverallBellStatus";
import BellOperationsConsole from "../BellOperationsConsole/BellOperationsConsole";

const OVERALL = "all";

function BellStatusPage() {
    const [schools, setSchools] = useState([]);
    const [view, setView] = useState(OVERALL); // "all" (overall) | schoolId
    const [lang, setLang] = useState(() => localStorage.getItem("dg-lang") || "en");

    useEffect(() => {
        let alive = true;
        (async () => {
            const {data} = await fetchSchools();
            if (alive) setSchools(data || []);
        })();
        return () => {
            alive = false;
        };
    }, []);

    const toggleLang = () => {
        const next = lang === "en" ? "ne" : "en";
        setLang(next);
        localStorage.setItem("dg-lang", next);
    };

    if (view === OVERALL) {
        return (
            <OverallBellStatus
                schools={schools}
                lang={lang}
                onToggleLang={toggleLang}
                onPickSchool={(id) => setView(String(id))}
            />
        );
    }

    return (
        <BellOperationsConsole
            schools={schools}
            schoolId={view}
            onSchoolChange={(id) => setView(String(id))}
            lang={lang}
            onToggleLang={toggleLang}
            onBackToOverall={() => setView(OVERALL)}
        />
    );
}

export default BellStatusPage;
